import {
    Stack,
    Grid,
    Typography,
    TextField,
    Checkbox,
    InputAdornment,
    IconButton,
    Link, 
    Select,
    MenuItem,
    InputLabel,
    // FromControl 
  } from '@mui/material';
  import FormControl from "@mui/material/FormControl";

  import { LoadingButton } from '@mui/lab';
  import { useCallback, useEffect, useState } from 'react';
  import Image from 'src/components/image';
  import PropTypes from 'prop-types';
  import Iconify from 'src/components/iconify';
  import {
    getSignupStatus,
    confirmInviteUser,
    getPublicOrganizationDetails,
  } from 'src/services/user.service';
  import { usePathname, useRouter } from 'src/routes/hooks';
  import { LoadingScreen } from 'src/components/loading-screen';
  import TermsAndPolicy from 'src/sections/terms-and-privacy';
  import { useResponsive } from 'src/hooks/use-responsive';
  import Logo from 'src/components/logo';

  export default function OrganizationDetailsView({
    orgName,
    country,
    state,
    orgSize,
    formErrors,
    isLoading,
    setOrgName,
    setCountry,
    setState,
    setTimeZone,
    setCurrency,
    setOrgSize,
    handleOnClick, }) {

    const countriesWithTimeZones = [
        { 
            name: 'IN', 
            currency:'INR',
            states: [
                { name: 'Andaman and Nicobar Islands', timeZone: 'IST' },
                { name: 'Andhra Pradesh', timeZone: 'IST' },
                { name: 'Arunachal Pradesh', timeZone: 'IST' },
                { name: 'Assam', timeZone: 'IST' },
                { name: 'Bihar', timeZone: 'IST' },
                { name: 'Chandigarh', timeZone: 'IST' },
                { name: 'Chhattisgarh', timeZone: 'IST' },
                { name: 'Dadra and Nagar Haveli', timeZone: 'IST' },
                { name: 'Daman and Diu', timeZone: 'IST' },
                { name: 'Delhi', timeZone: 'IST' },
                { name: 'Goa', timeZone: 'IST' },
                { name: 'Gujarat', timeZone: 'IST' },
                { name: 'Haryana', timeZone: 'IST' },
                { name: 'Himachal Pradesh', timeZone: 'IST' },
                { name: 'Jammu and Kashmir', timeZone: 'IST' },
                { name: 'Jharkhand', timeZone: 'IST' },
                { name: 'Karnataka', timeZone: 'IST' },
                { name: 'Kerala', timeZone: 'IST' },
                { name: 'Ladakh', timeZone: 'IST' },
                { name: 'Lakshadweep', timeZone: 'IST' },
                { name: 'Madhya Pradesh', timeZone: 'IST' },
                { name: 'Maharashtra', timeZone: 'IST' },
                { name: 'Manipur', timeZone: 'IST' },
                { name: 'Meghalaya', timeZone: 'IST' },
                { name: 'Mizoram', timeZone: 'IST' },
                { name: 'Nagaland', timeZone: 'IST' },
                { name: 'Odisha', timeZone: 'IST' },
                { name: 'Puducherry', timeZone: 'IST' },
                { name: 'Punjab', timeZone: 'IST' },
                { name: 'Rajasthan', timeZone: 'IST' },
                { name: 'Sikkim', timeZone: 'IST' },
                { name: 'Tamil Nadu', timeZone: 'IST' },
                { name: 'Telangana', timeZone: 'IST' },
                { name: 'Tripura', timeZone: 'IST' },
                { name: 'Uttar Pradesh', timeZone: 'IST' },
                { name: 'Uttarakhand', timeZone: 'IST' },
                { name: 'West Bengal', timeZone: 'IST' }
            ] ,
        },
        { 
            name: 'UK',
            currency:'GBP', 
            states: [
                { name: 'England', timeZone: 'GMT' },
                { name: 'Scotland', timeZone: 'GMT' },
                { name: 'Wales', timeZone: 'GMT' },
                { name: 'Northern Ireland', timeZone: 'GMT' }
            ] ,
            
        },
        { 
            name: 'US',
            currency: 'USD', 
            states: [
                { name: 'Alabama', timeZone: 'CST' },
                { name: 'Alaska', timeZone: 'AKST' },
                { name: 'Arizona', timeZone: 'MST' },
                { name: 'Arkansas', timeZone: 'CST' },
                { name: 'California', timeZone: 'PST' },
                { name: 'Colorado', timeZone: 'MST' },
                { name: 'Connecticut', timeZone: 'EST' },
                { name: 'Delaware', timeZone: 'EST' },
                { name: 'Florida', timeZone: 'EST' },
                { name: 'Georgia', timeZone: 'EST' },
                { name: 'Hawaii', timeZone: 'HST' },
                { name: 'Idaho', timeZone: 'MST' },
                { name: 'Illinois', timeZone: 'CST' },
                { name: 'Indiana', timeZone: 'EST' },
                { name: 'Iowa', timeZone: 'CST' },
                { name: 'Kansas', timeZone: 'CST' },
                { name: 'Kentucky', timeZone: 'EST' },
                { name: 'Louisiana', timeZone: 'CST' },
                { name: 'Maine', timeZone: 'EST' },
                { name: 'Maryland', timeZone: 'EST' },
                { name: 'Massachusetts', timeZone: 'EST' },
                { name: 'Michigan', timeZone: 'EST' },
                { name: 'Minnesota', timeZone: 'CST' },
                { name: 'Mississippi', timeZone: 'CST' },
                { name: 'Missouri', timeZone: 'CST' },
                { name: 'Montana', timeZone: 'MST' },
                { name: 'Nebraska', timeZone: 'CST' },
                { name: 'Nevada', timeZone: 'PST' },
                { name: 'New Hampshire', timeZone: 'EST' },
                { name: 'New Jersey', timeZone: 'EST' },
                { name: 'New Mexico', timeZone: 'MST' },
                { name: 'New York', timeZone: 'EST' },
                { name: 'North Carolina', timeZone: 'EST' },
                { name: 'North Dakota', timeZone: 'CST' },
                { name: 'Ohio', timeZone: 'EST' },
                { name: 'Oklahoma', timeZone: 'CST' },
                { name: 'Oregon', timeZone: 'PST' },
                { name: 'Pennsylvania', timeZone: 'EST' },
                { name: 'Rhode Island', timeZone: 'EST' },
                { name: 'South Carolina', timeZone: 'EST' },
                { name: 'South Dakota', timeZone: 'CST' },
                { name: 'Tennessee', timeZone: 'CST' },
                { name: 'Texas', timeZone: 'CST' },
                { name: 'Utah', timeZone: 'MST' },
                { name: 'Vermont', timeZone: 'EST' },
                { name: 'Virginia', timeZone: 'EST' },
                { name: 'Washington', timeZone: 'PST' },
                { name: 'West Virginia', timeZone: 'EST' },
                { name: 'Wisconsin', timeZone: 'CST' },
                { name: 'Wyoming', timeZone: 'MST' }
            ] 
        }
    ];
    

    const getStateOptions = () => {
        const selectedCountry = countriesWithTimeZones.find(item => item.name === country);
        return selectedCountry ? selectedCountry.states : [];
    };

    return (
        <Grid container justifyContent="center" sx={{ padding: 2, maxWidth:'600px' }}>
          <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <Typography variant="h2" sx={{marginBottom:'10px'}}>Organization Details</Typography>
                <InputLabel id="country-label" sx={{marginTop:'20px' , color:'black',fontWeight:500}}>Organization Name</InputLabel>
                <TextField
                  variant="outlined"
                  fullWidth
                  value={orgName}
                  onChange={(e) => setOrgName(e.target.value)}
                  required
                  error={!!formErrors?.orgName}
                  helperText={formErrors?.orgName}
                />
                <InputLabel id="country-label" sx={{marginTop:'20px' , color:'black',fontWeight:500}}>Country</InputLabel>
                <FormControl size="small" fullWidth>
                <InputLabel id="country-label">Select Country</InputLabel>
                <Select
                    labelId="country-label"
                    value={country}
                    onChange={(e) => {
                        const selectedCountry = e.target.value;
                        const selectedCountryData = countriesWithTimeZones.find(country => country.name === selectedCountry);
                        setCountry(selectedCountry);
                        setCurrency(selectedCountryData.currency); 
                    }}
                    fullWidth
                    required
                    error={!!formErrors?.country}
                    helperText={formErrors?.country}
                    displayEmpty
                >
                    <MenuItem value={'IN'}>India</MenuItem>
                    <MenuItem value={'UK'}>UK</MenuItem>
                    <MenuItem value={'US'}>USA</MenuItem>
                    
                </Select>
                </FormControl>
                <InputLabel id="country-label" sx={{marginTop:'20px' , color:'black',fontWeight:500}}>State</InputLabel>
                <FormControl size="small" fullWidth>
                <InputLabel id="state-label">Select State</InputLabel>
                <Select
                    labelId='state-label'
                    fullWidth
                    value={state}
                    onChange={(e) => {
                        const selectedState = e.target.value;
                        const selectedCountryData = countriesWithTimeZones.find(value => value.name === country);
                        const selectedStateData = selectedCountryData.states.find(state => state.name === selectedState);
                        setTimeZone(selectedStateData.timeZone);
                        setState(selectedState);
                    }}
                    required
                    error={!!formErrors?.state}
                    helperText={formErrors?.state}
                >
                    {getStateOptions().map(stateData => (
                        <MenuItem key={stateData.name} value={stateData.name} data={stateData}>
                            {stateData.name}
                        </MenuItem>
                    ))}
                </Select>
                </FormControl>
                <InputLabel id="country-label" sx={{marginTop:'20px' , color:'black',fontWeight:500}}>Organization Size</InputLabel>
                <FormControl size="small" fullWidth>
                <InputLabel id="size-label">Select Size</InputLabel>
                    <Select
                        labelId='size-label'
                        fullWidth
                        notched={false}
                        value={orgSize}
                        onChange={(e) => setOrgSize(e.target.value)}
                        error={!!formErrors?.orgSize}
                        helperText={formErrors?.orgSize}
                        required
                    >
                        <MenuItem value={'SMALL'}>Small (upto 10)</MenuItem>
                        <MenuItem value={'MEDIUM'}>Medium (upto 50)</MenuItem>
                        <MenuItem value={'LARGE'}>Large (greater than 50)</MenuItem>
                    </Select>
                </FormControl>
                
                <LoadingButton
                  type="button"
                  variant="contained"
                  fullWidth
                  loading={isLoading}
                  onClick={handleOnClick}
                  required
                >
                  Continue
                </LoadingButton>
              </Stack>
          </Grid>
        </Grid>
      );
  }